import { SEAT_HEIGHT } from '../constants';

import Side from './Side';
// TODO add logic to handle swept arm right side
export default class SweptArm extends Side {
  constructor(threekitApi, options = {}) {
    super(threekitApi, options);
    this._key = 'sweptArm';
    this.ArmSide = 'left';
    this.style = 'arm';

    this._initAlignmentWithConnector(options.connector);
  }

  _connectTo = (connector) => {
    const { target } = connector;
    if (target._type !== 'seat' && target._type !== 'anytable')
      throw new Error('Swept Arm can only connect to Seat');

    this._connectHelper({ ...connector, localSide: 'bottom' });
    target._updatePillow();
  };

  validateConnection = (item) => {
    return true;
  };
}
